import "./HomeDE.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import TrustBar from "./sections/TrustBar";
import AirportTransfer from "./sections/AirportTransfer";
import Destinations from "./sections/Destinations";
import HowItWorks from "./sections/HowItWorks";
import Confidence from "./sections/Confidence";
import Fleet from "./sections/Fleet";
import Testimonials from "./sections/Testimonials";
import TravelCare from "./sections/TravelCare";
import OtherServices from "./sections/OtherServices";
import TravelTips from "./sections/TravelTips";
import Faq from "./sections/Faq";
import Footer from "@/reusable_sections/Footer";
export default function HomeDEPage() {
  return <div>
      <Header />
      <Hero />
      <TrustBar />
      <AirportTransfer />
      <Destinations />
      <HowItWorks />
      <Confidence />
      <Fleet />
      <Testimonials />
      <TravelCare />
      <OtherServices />
      <TravelTips />
      <Faq />
      <Footer />
    </div>;
}